module.exports = __webpack_public_path__ + "static/media/de_gevolgen_voor_u.9082c78c.png";